import { createVNode as a, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/EditOutlinedStandard.js";
import o from "../components/PfIcon.js";
const t = (r, d) => {
  const e = {
    ...r,
    ...d.attrs
  };
  return a(o, i(e, {
    icon: n
  }), null);
};
t.displayName = "EditOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
